export default "__VITE_ASSET__tZMrWg7F__"